import { Box, Container, Typography } from "@mui/material";
import { SectionHeader } from "common/components/SectionHeader";
import React from "react";

export const Details = ({ data }) => {
  return (
    <Box
      py={{ xs: 8, md: 12 }}
      sx={{ backgroundColor: "var(--clr-warm-bg)" }}
    >
      <SectionHeader title={data.title} subtitle={data.subtitle} />
      <Container maxWidth="sm">
        <Typography
          variant="body1"
          color="textPrimary"
          textAlign="center"
          sx={{
            lineHeight: 2,
            fontSize: { xs: "0.9rem", md: "0.95rem" },
            color: "#4a4a4a",
          }}
        >
          {data.text1}
        </Typography>
        <Typography
          variant="body1"
          color="textPrimary"
          textAlign="center"
          mt={3}
          sx={{
            lineHeight: 2,
            fontSize: { xs: "0.9rem", md: "0.95rem" },
            color: "#4a4a4a",
          }}
        >
          {data.text2}
        </Typography>
      </Container>
    </Box>
  );
};
